import * as z from "zod";

export const getReturnsCohortRetentionInputSchema = z.object({
  cohortCount: z.number().int().min(1).max(52).default(16),
});
export type GetReturnsCohortRetentionInput = z.infer<
  typeof getReturnsCohortRetentionInputSchema
>;

/**
 * Weekly retention cohorts anchored by each team's first monetization-enabled
 * (`first_revenue`) lifecycle event.
 */
export const retentionCheckpointSchema = z.object({
  cohortStart: z.date(),
  daysSinceCohortStart: z.number().int().min(0),
  retentionPct: z.number().min(0).max(100),
  cohortSize: z.number().int().min(0),
});
export type RetentionCheckpoint = z.infer<typeof retentionCheckpointSchema>;

export const getReturnsCohortRetentionOutputSchema = z.object({
  checkpoints: z.array(retentionCheckpointSchema),
});
export type GetReturnsCohortRetentionOutput = z.infer<
  typeof getReturnsCohortRetentionOutputSchema
>;

export const getReturnsCohortRetention = {
  name: "getReturnsCohortRetention" as const,
  input: getReturnsCohortRetentionInputSchema,
  output: getReturnsCohortRetentionOutputSchema,
};
